<section class="templates-page">
  <div class="field-group">
    <label for="template">Шаблон</label>
    <select
      id="template"
      [disabled]="isLoadingTemplates()"
      [ngModel]="selectedTemplate()"
      (ngModelChange)="onTemplateChange($event)"
    >
      <option [ngValue]="defaultOption">Не выбрана</option>
      @for (item of templates(); track item.Code) {
        <option [ngValue]="item.Code">{{ item.Name }}</option>
      }
    </select>
  </div>

  <div class="workspace">
    <div class="template-column">
      <div class="editor-panel">
        <textarea
          [value]="templateText()"
          (input)="onTemplateInput($any($event.target).value)"
          [disabled]="isLoadingTemplate()"
          placeholder="Введите или отредактируйте шаблон"
        ></textarea>

        <div class="actions">
          <button type="button" class="secondary" (click)="clearTemplate()">Удалить</button>
          <button type="button" class="primary" (click)="saveTemplate()">Сохранить</button>
        </div>

        @if (status()) {
          <p class="status" [class.error]="statusIsError()">{{ status() }}</p>
        }
      </div>

      <div class="grid-panel">
        <div class="grid-toolbar">
          <input
            type="text"
            class="grid-search"
            [value]="searchTemplateId()"
            (input)="onSearchTemplateId($any($event.target).value)"
            placeholder="Поиск по PatientId"
          />
          <button type="button" class="secondary" (click)="refreshGridRows()" [disabled]="isLoadingGrid()">
            {{ isLoadingGrid() ? 'Обновление...' : 'Обновить' }}
          </button>
        </div>

        <div class="grid-scroll">
          <table class="templates-grid">
            <colgroup>
              <col [style.width.px]="columnWidths().Id" />
              <col [style.width.px]="columnWidths().PatientId" />
              <col [style.width.px]="columnWidths().SpecialtyCode" />
              <col [style.width.px]="columnWidths().History" />
            </colgroup>
            <thead>
              <tr>
                <th class="sortable" (click)="toggleGridSort('Id')">
                  <span class="th-label">Id {{ getSortMark('Id') }}</span>
                  <span class="resize-handle" (mousedown)="startResizeColumn('Id', $event)"></span>
                </th>
                <th class="sortable" (click)="toggleGridSort('PatientId')">
                  <span class="th-label">PatientId {{ getSortMark('PatientId') }}</span>
                  <span class="resize-handle" (mousedown)="startResizeColumn('PatientId', $event)"></span>
                </th>
                <th class="sortable" (click)="toggleGridSort('SpecialtyCode')">
                  <span class="th-label">SpecialtyCode {{ getSortMark('SpecialtyCode') }}</span>
                  <span class="resize-handle" (mousedown)="startResizeColumn('SpecialtyCode', $event)"></span>
                </th>
                <th>
                  <span class="th-label">History</span>
                  <span class="resize-handle" (mousedown)="startResizeColumn('History', $event)"></span>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (row of filteredTemplateRows(); track row.Id) {
                <tr (click)="selectPatientCard(row)" [class.selected-row]="isSelectedPatientRow(row)">
                  <td>{{ row.Id }}</td>
                  <td>{{ row.PatientId }}</td>
                  <td>{{ row.SpecialtyCode }}</td>
                  <td>
                    <div class="history-cell">{{ row.History }}</div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="dialog-column">
      <h3>Диалог</h3>

      <div class="chat-history" #chatHistory>
        @if (!chatMessages().length) {
          <p class="empty">Задайте вопрос.</p>
        }

        @for (message of chatMessages(); track $index) {
          <div class="chat-row" [class.user]="message.role === 'user'" [class.assistant]="message.role === 'assistant'">
            <div class="chat-role">
              {{ message.role === 'user' ? 'Вы' : 'Ассистент' }}
            </div>
            <div class="chat-message">
              {{ message.text }}
            </div>
          </div>
        }
      </div>

      <div class="chat-composer">
        <div class="chat-input-row">
          <textarea
            class="question-input"
            [value]="questionText()"
            (input)="onQuestionInput($any($event.target).value)"
            placeholder="Напишите сообщение"
          ></textarea>
          <button
            type="button"
            class="primary"
            [disabled]="isSendingQuestion() || !questionText().trim()"
            (click)="sendQuestion()"
          >
            {{ isSendingQuestion() ? 'Отправка...' : 'Отправить' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
